var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSendWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3567_5784)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.13244 2.68931L14.0004 7.99998L3.13244 13.3106C3.07041 13.3345 3.00269 13.3394 2.93788 13.3246C2.87307 13.3099 2.81409 13.2763 2.76844 13.228C2.72145 13.1784 2.6891 13.1168 2.67498 13.0499C2.66086 12.9831 2.66552 12.9137 2.68844 12.8493L4.33377 7.99998L2.68844 3.15065C2.66552 3.0863 2.66086 3.01686 2.67498 2.95002C2.6891 2.88318 2.72145 2.82156 2.76844 2.77198C2.81409 2.72368 2.87307 2.69004 2.93788 2.67532C3.00269 2.6606 3.07041 2.66547 3.13244 2.68931Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.33301 8H13.9997",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3567_5784"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendWhite);
export default __webpack_public_path__ + "static/media/send_white.612c1a5ae699bf92242aea54fa1dfb63.svg";
export { ForwardRef as ReactComponent };